import styled, { css } from 'styled-components';
import { lighten, darken } from 'polished';

import { fadeIn, fadeOut } from 'styles/animation';

interface MenuProps {
  disabled: boolean;
  size: string;
  $round: boolean;
  color: string;
  $fill: boolean;
}
interface MenuListProps {
  $visible: boolean;
  $isDropUp: boolean;
}
interface ItemProps {
  disabled: boolean;
}

export const Menu = styled.div<MenuProps>`
  position: relative;
  margin:auto;
  font-weight: 400;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  width:40px;
  height: 40px;
  line-height: 1.35em;


  box-shadow: none;
  cursor: ${props => (!props.disabled ? 'pointer' : 'not-allowed')};


  svg {
    margin: ${props => (props.color === 'font' ? '0' : '0 0 0 5px')};

    stroke-width: 2px;
    font-size: 18px;
  }

  ${props =>
    props.size === 'sm'
      ? css`
          font-size: 0.75rem;
          border-radius: 0.2857rem;
          padding: 5px 15px;
        `
      : props.size === 'lg'
      ? css`
          font-size: 0.875rem;
          border-radius: 0.4285rem;
          padding: 15px 28px;
        `
      : css`
          font-size: 0.875rem;
          border-radius: 0.4285rem;
          padding: 11px 20px;
        `}

  ${props =>
    props.$round
      ? css`
          padding: 4px;
          border-radius: 50%;
        `
      : null}


  ${props =>
    props.color === 'default'
      ? props.$fill
        ? css`
            color: ${props.theme.button.default.out};
            background: transparent;
            border: 1px solid ${props.theme.button.default.out};
            box-shadow: none;

            &:hover {
              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
              color: ${props.theme.button.default.out};
            }

            &:disabled {
              opacity: 0.7;
              color: ${lighten(0.5, props.theme.button.default.in)};
              border: 1px solid ${lighten(0.5, props.theme.button.default.in)};
              box-shadow: none;
              cursor: not-allowed;
            }
          `
        : css`
          color: ${lighten(0.5, props.theme.button.default.in)};
         background-image: linear-gradient(to bottom left,
          ${props.theme.button.default.out},
          ${props.theme.button.default.in},
          ${props.theme.button.default.out}) !important
          background-color: ${props.theme.button.default.out};
          &:hover {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            color: #fff;
          }
          &:disabled {
            opacity: 0.7;
            color:  ${lighten(0.5, props.theme.button.default.in)};
            border: 1px solid ${lighten(0.1, props.theme.button.default.out)};
            box-shadow: none;
            cursor: not-allowed;
          }
        `
      : props.color === 'primary'
      ? props.$fill
        ? css`
            color: ${props.theme.button.primary.out};
            background: transparent;
            border: 1px solid ${props.theme.button.primary.out};
            box-shadow: none;

            &:hover {
              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
              color: ${props.theme.button.primary.out};
            }

            &:disabled {
              opacity: 0.8;
              color: ${lighten(0.1, props.theme.button.primary.in)};
              border: 1px solid ${lighten(0.2, props.theme.button.primary.in)};
              box-shadow: none;
              cursor: not-allowed;
            }
          `
        : css`
       color: ${
         props.theme.name === 'dark'
           ? lighten(0.35, props.theme.button.primary.in)
           : lighten(0.55, props.theme.button.primary.in)
       };
         background-image: linear-gradient(to bottom left,
          ${props.theme.button.primary.out},
          ${props.theme.button.primary.in},
          ${props.theme.button.primary.out}) !important
          background-color: ${props.theme.button.primary.out};
          &:hover {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            color: #fff;
          }
          &:disabled {
            opacity: 0.6;
            color: ${lighten(0.35, props.theme.button.primary.in)};
            border: 1px solid ${lighten(0.2, props.theme.button.primary.in)};
            box-shadow: none;
            cursor: not-allowed;
          }
        `
      : props.color === 'font'
      ? props.$fill
        ? css`
            color: ${props.theme.fontColor};
            background: transparent;
            /* border: 1px solid ${props.theme.button.primary.out}; */
            box-shadow: none;

            &:hover {
              ${props =>
                props.theme.name === 'dark'
                  ? css`
                      background-color: ${props =>
                        lighten(0.1, props.theme.cardBackgroud)};
                    `
                  : css`
                      background-color: ${props =>
                        darken(0.1, props.theme.cardBackgroud)};
                    `}

            }

            &:disabled {
              opacity: 0.6;
              /* color: ${lighten(0.1, props.theme.button.primary.in)}; */
              border: 0;
              box-shadow: none;
              cursor: not-allowed;

              &:hover{
                background-color: transparent;
              }
            }
          `
        : css`
       color: ${lighten(0.35, props.theme.button.primary.in)};
         background-image: linear-gradient(to bottom left,
          ${props.theme.button.primary.out},
          ${props.theme.button.primary.in},
          ${props.theme.button.primary.out}) !important
          background-color: ${props.theme.button.primary.out};
          &:hover {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            color: #fff;
          }
          &:disabled {
            opacity: 0.6;
            color: ${lighten(0.35, props.theme.button.primary.in)};
            border: 1px solid ${lighten(0.2, props.theme.button.primary.in)};
            box-shadow: none;
            cursor: not-allowed;
          }
        `
      : props.color === 'success'
      ? props.$fill
        ? css`
            color: ${props.theme.button.success.out};
            background: transparent;
            border: 1px solid ${props.theme.button.success.out};
            box-shadow: none;

            &:hover {
              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
              color: ${props.theme.button.success.out};
              font-weight: 600;
            }

            &:disabled {
              opacity: 0.7;
              color: ${lighten(0.5, props.theme.button.success.in)};
              border: 1px solid ${lighten(0.5, props.theme.button.success.in)};
              box-shadow: none;
              cursor: not-allowed;
            }
          `
        : css`
          color: ${lighten(0.7, props.theme.button.success.in)};
         background-image: linear-gradient(to bottom left,
          ${props.theme.button.success.out},
          ${props.theme.button.success.in},
          ${props.theme.button.success.out}) !important
          background-color: ${props.theme.button.success.out};
          opacity: 0.9;
          &:hover {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            color: #fff;
            font-weight: 600;
            opacity: 1;
          }
          &:disabled {
            opacity: 0.6;
            color:  ${lighten(0.5, props.theme.button.success.in)};
            border: 1px solid ${lighten(0.1, props.theme.button.success.out)};
            box-shadow: none;
            cursor: not-allowed;
            &:hover {
              font-weight: 600;
          }
          }
        `
      : props.color === 'warn'
      ? props.$fill
        ? css`
            color: ${props.theme.button.warn.out};
            background: transparent;
            border: 1px solid ${props.theme.button.warn.out};
            box-shadow: none;
            opacity: 0.9;
            &:hover {
              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
              color: ${props.theme.button.warn.out};
              font-weight: 600;
              opacity: 1;
            }

            &:disabled {
              opacity: 0.6;
              color: ${lighten(0.5, props.theme.button.warn.in)};
              border: 1px solid ${lighten(0.5, props.theme.button.warn.in)};
              box-shadow: none;
              cursor: not-allowed;
            }
          `
        : css`
          color: ${lighten(0.5, props.theme.button.warn.in)};
         background-image: linear-gradient(to bottom left,
          ${props.theme.button.warn.in},
          ${props.theme.button.warn.out},
          ${props.theme.button.warn.in}) !important
          background-color: ${props.theme.button.warn.in};
          opacity: 0.9;
          &:hover {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            color: #fff;
            font-weight: 600;
            opacity: 1;
          }
          &:disabled {
            opacity: 0.6;
            color:  ${lighten(0.5, props.theme.button.warn.in)};
            border: 1px solid ${lighten(0.1, props.theme.button.warn.out)};
            box-shadow: none;
            cursor: not-allowed;
            &:hover {
              font-weight: 600;
          }
        `
      : props.color === 'danger'
      ? props.$fill
        ? css`
            color: ${props.theme.button.danger.out};
            background: transparent;
            border: 1px solid ${props.theme.button.danger.out};
            box-shadow: none;
            opacity: 0.9;
            &:hover {
              box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
              color: ${props.theme.button.danger.out};
              font-weight: 600;
              opacity: 1;
            }

            &:disabled {
              opacity: 0.7;
              font-weight: 600;
              color: ${lighten(0.5, props.theme.button.danger.in)};
              border: 1px solid ${lighten(0.5, props.theme.button.danger.in)};
              box-shadow: none;
              cursor: not-allowed;
            }
          `
        : css`
          color: ${lighten(0.5, props.theme.button.danger.in)};
         background-image: linear-gradient(to bottom left,
          ${props.theme.button.danger.out},
          ${props.theme.button.danger.in},
          ${props.theme.button.danger.out}) !important
          background-color: ${props.theme.button.danger.out};
          opacity: 0.9;
          &:hover {
            box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
            color: #fff;
            font-weight: 600;
            opacity: 1;
          }
          &:disabled {
            &:disabled {
            opacity: 0.6;
            color:  ${lighten(0.5, props.theme.button.danger.in)};
            border: 1px solid ${lighten(0.1, props.theme.button.danger.out)};
            box-shadow: none;
            cursor: not-allowed;
            &:hover {
              font-weight: 600;
          }
          }
          }
        `
      : ``}




background-size: 210% 210%;
background-position: 100% 0;

transition: all 0.15s ease;
`;

export const MenuList = styled.ul<MenuListProps>`
  position: absolute;
  left: auto;
  right: 10px;
  z-index: 1000;
  ${props =>
    props.$isDropUp
      ? css`
          bottom: 3rem;
        `
      : css`
          top: 3rem;
        `}
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;

  text-align: left;
  border-radius: 4px;
  background-color: #fff;
  background-clip: padding - box;
  border: 0 solid rgba(34, 42, 66, 0.15);
  box-shadow: 0 1px 2px rgba(50, 50, 93, 0.1),
    0 15px 35px rgba(50, 50, 93, 0.15), 0 5px 15px rgba(0, 0, 0, 0.1);
  user-select: none;

  ${props =>
    props.$visible
      ? css`
          animation: ${fadeIn} 0.1s ease-in;
          display: block;
        `
      : css`
          /* animation: ${fadeOut} 0.1s ease-out; */
          display: none;
          opacity: 0;
          background: green;
        `}

  &::before {
    display: inline-block;
    position: absolute;
    width: 0;
    height: 0;
    vertical-align: middle;
    content: '';
    left: auto;
    right: 10px;
    color: #fff;
    ${props =>
      props.$isDropUp
        ? css`
            bottom: -5px;
            border-top: 0.4em solid;
          `
        : css`
            top: -5px;
            border-bottom: 0.4em solid;
          `}
    border-right: 0.4em solid transparent;
    border-left: 0.4em solid transparent;
  }
`;

export const Item = styled.li<ItemProps>`
  padding: 0.25rem 0.5rem;
  list-style: none;

  div,
  a {
    background: none;
    justify-content: flex-start !important;
    border: none;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.menu.fontColor};
    font-size: 0.75rem;
    padding: 0.6rem 0.25rem 0.6rem 0.5rem;
    text-decoration: none;

    -webkit-transition: all 0.15s linear;
    transition: all 0.15s linear;
    span {
      color: ${props => props.theme.menu.fontColor} !important;
    }
    &:hover {
      background-color: hsla(0, 0%, 87.1%, 0.3);
    }

    svg {
      margin-right: 1rem;
    }

    ${props =>
      props.disabled &&
      css`
      opacity: 0.6 !important;
      cursor: not-allowed !important;
      &:hover {
        background-color: transparent;
      }
    }
    `}
  }
`;
